import api from "../api";
import axios from "../utils/axios.instance";
import handleError from "./handle-error";

export const profileImage = async () => {
  return await axios.get(api.profileImage);
};

export const uploadUrl = async (url, payload, options = {}) => {
  try {
    const response = await fetch(url, {
      method: options.method || "POST",
      headers: options.headers,
      body: payload,
    });
    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`);
    }

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      const responseData = await response.json();
      return responseData.result ?? responseData;
    }

    const responseText = await response.text();
    return responseText;
  } catch (err) {
    console.error(err);
    return handleError(err);
  }
};

export const chatMediaUploadUrl = async (contentType) => {
  try {
    const params = new URLSearchParams();
    if (contentType) params.append("contentType", contentType);
    const { data } = await axios.get(
      `${api.chatMediaUpload}${params.toString() ? `?${params.toString()}` : ""}`,
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const chatMediaObjectUrl = async (uid) => {
  try {
    const { data } = await axios.get(api.chatMediaUrl(uid));
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const uploadChatMedia = async (formData) => {
  try {
    const { data } = await axios.post(api.chatMediaUploadProxy, formData);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
